import React from "react";
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend,
} from "chart.js";
import { Bar } from "react-chartjs-2";

ChartJS.register(
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend
);



const BarChart = ({titleAnalytics}) => {
  const dataValues = titleAnalytics?.titlesEarnedAge.map((item) => item.count);
  const options = {
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
      legend: {
        display: false,
      },
      chartAreaBorder: {
        borderColor: "red",
        borderWidth: 2,
        borderDash: [5, 5],
        borderDashOffset: 2,
      },
    },
    scales: {
      x: {
        display: true,
        title: {
          display: true,
          text: "Age",
        },
        grid: {
          display: false,
        },
      },
      y: {
        display: true,
        title: {
          display: true,
          text: "No. of Titles",
        },
        grid: {
          display: false,
        },
        ticks: {
          callback: function(value, index, values) {
            return value * 1;
          }
        }
      },
    },
  };
  
  const labels = ["0-1", "2", "3", "4", "5", "6", "7", "8+"];
  
  const data = {
    labels,
    datasets: [
      {
        data: dataValues,
        backgroundColor: [
          "#FDA29B",
          "#84ADFF",
          "#FDA29B",
          "#84ADFF",
          "#FDA29B",
          "#84ADFF",
          "#FDA29B",
          "#84ADFF",
        ],
        barThickness: 10,
        borderRadius: 3,
      },
    ],
  };
  return <Bar options={options} data={data} />;
};

export default BarChart;
